<template>
  <div class="nav-btn">
    <div class="btn" @click="onClick" :style="{backgroundImage: formatImg(imgUrl)}"></div>
  </div>
</template>
<style lang='scss' scoped>
  .nav-btn {
    position: fixed;
    top: 36px;
    left: 50%;
    z-index: 100;
    transform: translateX(-167px);

    .btn {
      width: 32px;
      height: 32px;
      border-radius: 100%;
      background-size: 100% 100%;
      background-repeat: no-repeat;
    }
  }
  @media only screen and (device-height: 812px) {
    .nav-btn {
      top: 45px;
    }
  }
</style>
<script>
  export default {
    props: {
      imgUrl: {
        type: String,
        default: '//cdn.hongbaoxd.com/images/67df4af4855f1abe791a2a70f0b4c662.png'
      },
      onClick: Function
    },
    methods: {
      formatImg (img) {
        return `url("${img}")`
      }
    }
  }
</script>
